import React, { useEffect, useState } from 'react';
import AppSelect from '../../../components/atoms/AppSelect/AppSelect';
import { AppMultiselect } from '../../../components/molecules/AppMultiselect/AppMultiselect';

export interface SelectProps {
  label: string;
  value: string;
}

export interface GeolocationFormState {
  countryCode: string;
  values: SelectProps[];
}

interface SwitchCriteriaFormProps {
  countries: SelectProps[];
  cities: SelectProps[];
  value?: GeolocationFormState;
  onChange: (e: GeolocationFormState) => void;
  onCountryChange?: (countryCode: string) => void;
  loadingCities?: boolean;
  citiesTitle: string;
}

export const GeolocationCriteriaForm = ({
                                          countries,
                                          cities,
                                          onChange,
                                          onCountryChange,
                                          loadingCities,
                                          value,
                                          citiesTitle,
                                        }: SwitchCriteriaFormProps) => {
  const [formState, setFormState] = useState<GeolocationFormState>(value || {
    countryCode: countries[0]?.value || '',
    values: [],
  });

  useEffect(() => {
    onChange(formState);
  }, [formState]);

  // Disparar carga de ciudades al montar con el valor inicial (primer país o valor previo)
  useEffect(() => {
    if (formState.countryCode) {
      onCountryChange?.(formState.countryCode);
    }
  }, []);

  const handleCountryChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    const newCountryCode = e.target.value;
    setFormState({ countryCode: newCountryCode, values: [] });
    onCountryChange?.(newCountryCode);
  };

  return (
    <div className="flex w-full items-center gap-4">
      <div className={'min-w-72'}>
        <AppSelect
          options={countries}
          label={'Pais'}
          value={formState.countryCode}
          onChange={handleCountryChange}
        />
      </div>

      <label className={'flex flex-col text-left text-sm text-shark-800 min-w-72'}>
        {citiesTitle}
        <div className="mt-1">
          {loadingCities ? (
            <div className="flex items-center h-11 px-3.5 border border-ebony-950/15 rounded-lg text-gray-400 bg-[#E2E8F080]">
              Cargando...
            </div>
          ) : (
            <AppMultiselect key={formState.countryCode}
                            value={formState.values}
                            isSearchable
                            onChange={(values) => setFormState({ ...formState, values })}
                            options={cities} />
          )}
        </div>
      </label>
    </div>
  );
};
